const encoder = new TextEncoder();

/**
 * Byte length of a string once encoded as UTF-8, which is what the backend measures a property value
 * against — a character count would under-report anything outside ASCII.
 */
export function getUtf8ByteLength(value: string): number {
  return encoder.encode(value).length;
}
